export const FETCH_REPORT_DELAY = 3000
